import { BiChip } from '@euler/app/flows/bi-dashboards/components/ui/BiChip';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import {
  BiGalleryWidth,
  kBiGalleryWidths,
} from '../../functions/biGalleryWidth';
import { PaletteChip } from './PaletteChip';
import { ToolbarRow } from './ToolbarRow';

/** The page's palette and preview width. */
export const GalleryToolbar = memo(
  ({
    palette,
    width,
    onPalette,
    onWidth,
  }: {
    palette: BiPalette;
    width: BiGalleryWidth;
    onPalette: (palette: BiPalette) => void;
    onWidth: (width: BiGalleryWidth) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(8) }}>
        <ToolbarRow label="配色">
          {Object.values(BiPalette).map(option => (
            <PaletteChip
              key={option}
              palette={option}
              selected={option === palette}
              onPress={onPalette}
            />
          ))}
        </ToolbarRow>
        <ToolbarRow label="宽度">
          {Object.values(BiGalleryWidth).map(option => (
            <BiChip
              key={option}
              label={kBiGalleryWidths[option].label}
              selected={option === width}
              onPress={() => onWidth(option)}
            />
          ))}
        </ToolbarRow>
      </View>
    );
  },
);
